const child = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: 'home',
    name: 'home',
    component: () => import('@/pages/home/WelcomePage')
  },


  {
    path: 'codeList',
    name: 'codeList',
    component: () => import('@/pages/modules/system/code/CodeListPage')
  },


  {
    path: 'menuList',
    name: 'menuList',
    component: () => import('@/pages/modules/system/menu/MenuListPage')
  },

  {
    path: 'roleList',
    name: 'roleList',
    component: () => import('@/pages/modules/system/role/RoleListPage')
  },

  {
    path: 'sysUserList',
    name: 'sysUserList',
    component: () => import('@/pages/modules/system/user/UserListPage')
  },

  {
    path: 'modifyUserPass',
    name: 'modifyUserPass',
    component: () => import('@/pages/modules/system/user/ModifyUserPassPage')
  },

  {
    path: 'saveUser',
    name: 'saveUser',
    component: () => import('@/pages/modules/system/user/SaveUserPage')
  },


  {
    path: 'saveCode',
    name: 'saveCode',
    component: () => import('@/pages/modules/system/code/SaveCodePage')
  },

  {
    path: 'saveRole',
    name: 'saveRole',
    component: () => import('@/pages/modules/system/role/SaveRolePage')
  },

  {
    path: 'saveMenu',
    name: 'saveMenu',
    component: () => import('@/pages/modules/system/menu/SaveMenuPage')
  },

  {
    path: 'dispatcherPermission',
    name: 'dispatcherPermission',
    component: () => import('@/pages/modules/system/role/DispatcherPermissionPage')
  },
  {
    path: 'nginxAnlysis',
    name: 'nginxAnlysis',
    component: () => import('@/pages/modules/nginx/NginxPage')
  },

  {
    path: 'event',
    name: 'event',
    component: () => import('@/pages/modules/nginx/ServerEventPage.vue')
  },

  {
    path: 'sysRobotList',
    name: 'sysRobotList',
    component: () => import('@/pages/modules/system/robot/SysRobotListPage.vue')
  },
  {
    path: 'saveSysRobot',
    name: 'saveSysRobot',
    component: () => import('@/pages/modules/system/robot/SaveSysRobotPage.vue')
  },
  {
    path: 'changeLog',
    name: 'changeLog',
    component: () => import('@/pages/modules/changelog/ChangeLogPage.vue')
  },

  {
    path: 'assetList',
    name: 'assetList',
    component: () => import('@/pages/modules/system/asset/AssetAdminListPage.vue')
  },

  {
    path: 'saveAsset',
    name: 'saveAsset',
    component: () => import('@/pages/modules/system/asset/AssetAdminFormPage.vue')
  },

  {
    path: 'sysRuleList',
    name: 'sysRuleList',
    component: () => import('@/pages/modules/system/sysrule/SysRuleListPage.vue')
  },

  {
    path: 'saveSysRule',
    name: 'saveSysRule',
    component: () => import('@/pages/modules/system/sysrule/SysRuleFormPage.vue')
  },


  {
    path: 'idCardValidate',
    name: 'idCardValidate',
    component: () => import('@/pages/modules/idcard/IdCardValidatePage.vue')
  },

  {
    path: 'sysProjectList',
    name: 'sysProjectList',
    component: () => import('@/pages/modules/system/sysproject/SysProjectListPage.vue')
  },

  {
    path: 'saveSysProject',
    name: 'saveSysProject',
    component: () => import('@/pages/modules/system/sysproject/SysProjectFormPage.vue')
  },

  {
    path: 'dispatchDeveloper',
    name: 'dispatchDeveloper',
    component: () => import('@/pages/modules/system/sysproject/DispatchDeveloperPage.vue')
  },


  {
    path: 'serviceList',
    name: 'serviceList',
    component: () => import('@/pages/modules/system/asset/ServiceAdminListPage.vue')
  },

  {
    path: 'sysTestReportList',
    name: 'sysTestReportList',
    component: () => import('@/pages/modules/system/systestreport/SysTestReportListPage.vue')
  },

  {
    path: 'sysAutoTestCaseList',
    name: 'sysAutoTestCaseList',
    component: () => import('@/pages/modules/system/sysproject/SysAutoTestCaseListPage.vue')
  },

  {
    path: 'setUpSteps',
    name: 'setUpSteps',
    component: () => import('@/pages/modules/system/sysproject/setUpStepListPage.vue')
  },


  {
    path: 'saveSysTestReport',
    name: 'saveSysTestReport',
    component: () => import('@/pages/modules/system/systestreport/SysTestReportFormPage.vue')
  },
  {
    path: 'saveSysAutoTestCase',
    name: 'saveSysAutoTestCase',
    component: () => import('@/pages/modules/system/sysproject/SysAutoTestCaseFormPage.vue')
  },

  {
    path: 'sysDepositoryList',
    name: 'sysDepositoryList',
    component: () => import('@/pages/modules/system/sysdepository/SysDepositoryListPage.vue')
  },

  {
    path: 'saveSysDepository',
    name: 'saveSysDepository',
    component: () => import('@/pages/modules/system/sysdepository/SysDepositoryFormPage.vue')
  },

  {
    path: 'logView',
    name: 'logView',
    component: () => import('@/pages/modules/system/logview/LogViewListPage.vue')
  },

  {
    path: 'gitBranch',
    name: 'gitBranch',
    component: () => import('@/pages/modules/system/tools/GitBranchTool.vue')
  },
  {
    path: 'frontMonitor',
    name: 'frontMonitor',
    component: () => import('@/pages/modules/system/monitor/FrontMonitor.vue')
  },
  {
    path: 'decode',
    name: 'decode',
    component: () => import('@/pages/modules/system/tools/DecodeUtils.vue')
  },
  {
    path: 'email',
    name: 'email',
    component: () => import('@/pages/modules/system/tools/EmailUtils.vue')
  },
  {
    path: '/connectorCategoryList',
    name: 'connectorCategoryList',
    meta: {
      Title: '实体描述信息列表'
    },
    component: () => import('@/pages/modules/system/connectorCategory/connectorCategoryList')
  },

  {
    path: '/saveconnectorCategory',
    name: 'saveconnectorCategory',
    meta: {
      Title: '保存实体描述信息'
    },
    component: () => import('@/pages/modules/system/connectorCategory/connectorCategoryForm')
  },

  {
    path: '/connectorBasicList',
    name: 'connectorBasicList',
    meta: {
      Title: '实体描述信息列表'
    },
    component: () => import('@/pages/modules/system/connectorBasic/connectorBasicList')
  },

  {
    path: '/saveConnectorBasic',
    name: 'saveConnectorBasic',
    meta: {
      Title: '保存实体描述信息'
    },
    component: () => import('@/pages/modules/system/connectorBasic/connectorBasicForm')
  },
  {
    path: '/connectorParamsList',
    name: 'connectorParamsList',
    meta: {
      Title: '实体描述信息列表'
    },
    component: () => import('@/pages/modules/system/connectorParams/connectorParamsList')
  },

  {
    path: '/saveconnectorParams',
    name: 'saveconnectorParams',
    meta: {
      Title: '保存实体描述信息'
    },
    component: () => import('@/pages/modules/system/connectorParams/connectorParamsForm')
  },

  {
    path: '/connectors',
    name: 'connectors',
    meta: {
      Title: '实体描述信息列表'
    },
    component: () => import('@/pages/modules/system/connectors/ConnectorListPage')
  },


  {
    path: '/smsLogList',
    name: 'smsLogList',
    meta: {
      Title: '默认描述信息列表'
    },
    component: () => import('@/pages/modules/system/smsLog/smsLogListPage')
  },

  {
    path: '/savesmsLog',
    name: 'savesmsLog',
    meta: {
      Title: '保存默认描述信息'
    },
    component: () => import('@/pages/modules/system/smsLog/smsLogFormPage')
  },

  {
    path: '/sysUserLoginLogList',
    name: 'sysUserLoginLogList',
    meta: {
      Title: '默认描述信息列表'
    },
    component: () => import('@/pages/modules/system/sysUserLoginLog/sysUserLoginLogListPage')
  },

  {
    path: '/savesysUserLoginLog',
    name: 'savesysUserLoginLog',
    meta: {
      Title: '保存默认描述信息'
    },
    component: () => import('@/pages/modules/system/sysUserLoginLog/sysUserLoginLogFormPage')
  },
]

const routers = [
  {
    path: '/',
    component: () => import('@/pages/home/HomePage'),
    children: child
  },
  {
    path: '/login',
    component: () => import('@/pages/home/LoginPage'),
  },
]
export default routers